import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const HowItWorks = lazy(() => import("@/components/HowItWorks"));
const Products = lazy(() => import("@/components/Products"));
const Testimonials = lazy(() => import("@/components/Testimonials"));
const Certifications = lazy(() => import("@/components/Certifications"));
const FAQ = lazy(() => import("@/components/FAQ"));
const CTA = lazy(() => import("@/components/CTA"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  useDocumentMeta({
    title: "سعدتك | صحتك في تركيبتك — مكملات غذائية طبيعية DXN",
    description: "اكتشف المكملات الغذائية الطبيعية المثالية لجسمك من خلال استبيان شخصي. منتجات DXN معتمدة حلال وعالمياً. ريشي، سبيرولينا، كورديسيبس والمزيد.",
    canonicalUrl: "https://www.saadtak.com",
  });

  return (
    <div className="min-h-screen bg-background" dir="rtl">
      <Header />
      <main>
        <Hero />
        <Suspense fallback={null}>
          <HowItWorks />
          <Products />
          <Testimonials />
          <Certifications />
          <FAQ />
          <CTA />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
